/** Shared photo fallback identity for React surfaces and the installed native shell. */
export function avatarIdentity(name: string, id: string) {
  const safeName = name.replace(/[\uD800-\uDFFF]/gu, '\uFFFD').trim();
  const words = safeName.split(/\s+/);
  const initials = (words.length > 1 ? ([...(words[0] ?? '')][0] ?? '') + ([...(words.at(-1) ?? '')][0] ?? '') : [...safeName].slice(0, 2).join('')).toUpperCase() || '?';
  const tone = [...id].reduce((hash, char) => (hash * 31 + char.charCodeAt(0)) % 4, 0);
  return { initials, tone };
}

/** The existing Desktop overlay accepts an image URL, not a React component. */
export function avatarMonogramUrl(name: string, id: string) {
  const { initials, tone } = avatarIdentity(name, id);
  const text = initials.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
  const fill = ['#30383D', '#373431', '#2E3936', '#373833'][tone];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"><rect width="80" height="80" rx="24" fill="${fill}"/><text x="40" y="42" text-anchor="middle" dominant-baseline="middle" font-family="Arial,sans-serif" font-size="26" font-weight="600" fill="#EEE9E1">${text}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
